// extracted by mini-css-extract-plugin
export default {"contentWrapper":"styles_contentWrapper__kisg-","activeItems":"styles_activeItems__2bss1","archiveItems":"styles_archiveItems__uJal-","description":"styles_description__hsZV5"};